module.exports = __webpack_public_path__ + "img/d.6ed25748.jpg";